import { useQuery } from '@tanstack/react-query'

import { getCanActivateCard } from '@src/api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchCanActivateCard = (organizationId: string) => {
  const { axiosInstance } = useAxios()
  return useQuery({
    enabled: !!organizationId,
    queryFn: () => getCanActivateCard(axiosInstance, { organizationId }),
    queryKey: [REACT_QUERY_CACHE_KEYS.GET_CAN_ACTIVATE_CARD],
  })
}
